import * as React from 'react'

export const Alert = ({
  style,
  callback,
  disabled = false,
  readOnly = false
}) => {
  return (
    <input
      type="range"
      style={style}
      disabled={disabled}
      readOnly={readOnly}
      onChange={({ target: { value } }) => callback(value)}
    />
  )
}

export default Alert
